import React, { Suspense, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF, Center, Environment } from '@react-three/drei';

const Model = ({ src }) => {
  const { scene } = useGLTF(src);
  return <primitive object={scene} />;
};

const LoadingFallback = () => (
  <mesh>
    <boxGeometry args={[1, 1, 1]} />
    <meshStandardMaterial color="#c4c4c0" wireframe />
  </mesh>
);

const ModelViewer = ({ modelSrc }) => {
  const containerRef = useRef(null);

  if (!modelSrc) return null;

  return (
    <div
      ref={containerRef}
      className="relative w-full rounded-[10px] sm:rounded-[15px] md:rounded-[20px] overflow-hidden"
      style={{ aspectRatio: '16 / 9', background: '#1a1a18' }}
    >
      <Canvas
        camera={{ position: [0, 1, 4], fov: 45 }}
        dpr={[1, 2]}
        gl={{ antialias: true, alpha: false }}
        style={{ background: '#1a1a18' }}
      >
        <ambientLight intensity={0.4} />
        <directionalLight position={[5, 8, 5]} intensity={1} castShadow />
        <directionalLight position={[-5, 3, -5]} intensity={0.3} />

        <Suspense fallback={<LoadingFallback />}>
          <Center>
            <Model src={modelSrc} />
          </Center>
          <Environment preset="city" />
        </Suspense>

        <OrbitControls
          enablePan={true}
          enableZoom={true}
          enableRotate={true}
          minDistance={1}
          maxDistance={20}
          autoRotate={false}
        />
      </Canvas>

      {/* Drag hint overlay */}
      <div className="absolute bottom-4 right-4 pointer-events-none select-none">
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white/60 text-xs font-['Space_Grotesk',_sans-serif]">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-3.5 h-3.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59" />
          </svg>
          Drag to rotate
        </span>
      </div>
    </div>
  );
};

export default ModelViewer;
